import * as z from "zod/v4";

export const getMarketingAgentSplitTestRevenueChart = {
  name: "getMarketingAgentSplitTestRevenueChart" as const,
  input: z.object({
    teamId: z.string(),
    splitId: z.string(),
    days: z.number().int().positive(),
  }),
  output: z
    .object({
      data: z.array(
        z.object({
          date: z.string(),
          variant: z.number(),
          control: z.number(),
        }),
      ),
    })
    .nullable(),
};
